import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

import printIcon from "../../assets/icons/printIcon.svg";
import logo from "../../assets/images/logomain.svg";

const PaymentLinkPrint = ({ form, qrCode }) => {
  const contentRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const reactToPrintFn = useReactToPrint({
    contentRef: contentRef,
    documentTitle: "",
  });

  return (
    <div
      className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg border border-[#ccc] p-1"
      title="پرینت فرم"
    >
      <button onClick={reactToPrintFn} disabled={isLoading}>
        {isLoading ? "در حال بارگیری..." : <img src={printIcon} alt="QR Code" />}
      </button>
      <div style={{ display: "none" }}>
        <div ref={contentRef}>
          <div className="flex-center border-primary-100 h-screen w-screen flex-col gap-12 rounded-lg border-4 bg-white">
            <p className="flex-center text-[22px] font-bold">{form?.name}</p>
            {qrCode && <img src={qrCode} alt="QR Code" className="h-96 w-96" />}

            <div className="flex flex-col items-center justify-center gap-1">
              <img src={logo} alt="QR Code" className="h-24 w-24" />

              <p className="flex-center text-[14px] tracking-tight">پرداخت امن با ونداپرداخت</p>
              <a
                className="flex-center font-semibold tracking-widest text-[16x]"
                href="https://www.vandapardakht.ir/"
              >
                vandapardakht.ir
              </a>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media all {
          .page-break {
            display: none;
          }
        }

        @media print {
          .page-break {
            display: block;
            page-break-before: auto;
            margin-top: 1rem;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: visible;
            -webkit-print-color-adjust: exact;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          /* Make your print content fill the page */
          .print-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: white;
          }
        }

        @page {
          size: auto;
          margin: 0; /* Remove default margin to avoid clipping */
        }
      `}</style>
    </div>
  );
};

export default PaymentLinkPrint;
